import React from 'react';
import { ArrowRight } from 'lucide-react';

const Hero = ({ translations }) => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              {translations.hero.title}
            </h1>
            <p className="hero-subtitle">
              {translations.hero.subtitle}
            </p>
            <div className="hero-buttons">
              <button className="btn-primary" onClick={scrollToContact}>
                {translations.hero.cta}
                <ArrowRight size={20} style={{ marginLeft: '8px' }} />
              </button>
            </div>
          </div>
          <div className="hero-image">
            <img 
              src="https://images.unsplash.com/photo-1673515335152-f2589ba8bb7a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjB0cmFuc2xhdGlvbnxlbnwwfHx8fDE3Njk4ODMzNTB8MA&ixlib=rb-4.1.0&q=85"
              alt="Professional Translation Services"
              className="hero-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
